import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import zhTWTranslation from './locales/zh-TW.json';
import comorbidityManagementTranslation from './locales/zh/comorbidity-management.json';
import vaccinationTranslation from './locales/zh/vaccination.json';
import oxygenTherapyTranslation from './locales/zh/oxygen-therapy.json';
import pulmonaryRehabilitationTranslation from './locales/zh/pulmonary-rehabilitation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      'zh-TW': {
        translation: zhTWTranslation,
        comorbidityManagement: comorbidityManagementTranslation,
        vaccination: vaccinationTranslation,
        pulmonaryRehabilitation: pulmonaryRehabilitationTranslation,
        oxygenTherapy: oxygenTherapyTranslation
      }
    },
    fallbackLng: 'zh-TW',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 